import { Component, OnInit, Input } from '@angular/core';
import { counterPartyReport } from './counterparty-report.model';
import { FinraExceptionService } from '../finra-exception.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'app/Shared/Services/user.service';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { MessageService } from 'primeng/api';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import {default as listCols} from '../counterparty-report.json';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { DatepickerService } from 'app/Shared/Component/datepicker-calendar/datepicker.service';
import { DatepickerCalendarComponent } from 'app/Shared/Component/datepicker-calendar/datepicker-calendar.component';
@Component({
    selector: 'app-counterparty-party-report',
    imports: [DialogModule, MultiSelectModule, MatTooltipModule, MatCheckboxModule, FormsModule, MatDividerModule, MatButtonModule, DatepickerCalendarComponent],
    templateUrl: './counterparty-report.component.html',
    styleUrls: ['./counterparty-report.component.scss']
})
export class CounterpartyPartyReportComponent implements OnInit {
  isVisible: boolean = true;
  counterPartyReport: counterPartyReport = new counterPartyReport();
  destinationList: Array<any> = [];
  senderIMID:Array<any> = [];
  isIndividualFile:boolean = false;
  filters: any;
  exportFilesData: Array<any> = [];
  @Input() filter!: any;
  constructor(public finraExceptionService: FinraExceptionService, 
              public userService: UserService,
              public constantService: ConstantService,
              public messageService: MessageService,
              public emitterService: EmitterService,
              private datepickerService : DatepickerService) { 
   
  }

  ngOnInit() {  
    this.counterPartyReport.reportDate = this.finraExceptionService.defaultFilters[0].values;
    
    this.getDestinationList();
  }
  getDestinationList() {
    this.finraExceptionService.getDestinationList(
      [this.userService.getyyyyMMddDateFormate(this.counterPartyReport.reportDate[0]),
      this.counterPartyReport.reportDate[1] !== null 
      ?this.userService.getyyyyMMddDateFormate(this.counterPartyReport.reportDate[1]) :
      this.userService.getyyyyMMddDateFormate(this.counterPartyReport.reportDate[0])]
    )
    .subscribe({
      next: (data:any) => {
      this.destinationList = data.destinationType;
      this.senderIMID = data.senderIMID;
      // for 9003 exception code 
      let isDestinationPresent = true;
        this.finraExceptionService.defaultFilters.forEach(filter => {
          if (filter.label === 'Code' && filter.values === '9003') {
            isDestinationPresent = false;
          }
        });
        if(!isDestinationPresent) {
          this.destinationList = [];
        }
      this.counterPartyReport.destination = this.getAllDestination();
      this.counterPartyReport.senderIMID = this.getAllReportIMID();
    },error: (err: HttpErrorResponse) => {

    }});
  }
  getAllDestination() {
    let destinations:Array<string> = [];
    this.destinationList.forEach((obj)=> {
     destinations.push(obj.value)
    })
    return destinations
  }
  getAllReportIMID() {
    let receiverIMIDs:Array<string> = [];
    this.senderIMID.forEach((obj)=> {
      receiverIMIDs.push(obj.value)
    })
    return receiverIMIDs
  }
  generateFile() {
    if(this.isIndividualFile) {
      if(this.counterPartyReport.destination.length> 0) {
        this.counterPartyReport.destination.forEach((destination: any) => {
          this.filters = [];
          this.filters = this.finraExceptionService.defaultFilters.slice();
              this.filters.push( {
                "isdefault": false,
                "label": "destination",
                "columnname": "destination",
                "filterby": "IN",
                "values": destination,
                "time": "",
                "datatype": "String",
                "disabled": "false"
              })
            this.getData('destination',destination);
        });
      }

      if(this.counterPartyReport.senderIMID.length> 0) {
        this.counterPartyReport.senderIMID.forEach((senderIMID: any) => {
          this.filters = [];
          this.filters = this.finraExceptionService.defaultFilters.slice();
              this.filters.push( {
                "isdefault": false,
                "label": "senderIMID",
                "columnname": "senderIMID",
                "filterby": "IN",
                "values": senderIMID,
                "time": "",
                "datatype": "String",
                "disabled": "false"
              })
            this.getData('senderIMID',senderIMID);
        });
      }
    } else {
      this.filters = [];
      this.filters = this.finraExceptionService.defaultFilters.slice();
      this.filters.push({
        "isdefault": false,
        "label": "destination",
        "columnname": "destination",
        "filterby": "IN",
        "values": this.counterPartyReport.destination.toString(),
        "time": "",
        "datatype": "String",
        "disabled": "false"
      })
      this.filters.push({
        "isdefault": false,
        "label": "senderIMID",
        "columnname": "senderIMID",
        "filterby": "IN",
        "values": this.counterPartyReport.senderIMID.toString(),
        "time": "",
        "datatype": "String",
        "disabled": "false"
      })
      this.getData('destination,senderIMID');
    }
  }
  getData(sortBy?:string, value?: any) {
   this.messageService.add({ severity: 'warn', summary: 'CounterParty Report', detail: 'Counter Party Report Generation Started' });

   let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
   this.filters[0].values =  this.counterPartyReport.reportDate;
   this.filters[3].values = this.counterPartyReport.symbol;
   sortBy = sortBy ?? "";
    this.finraExceptionService
      .getFinraExceptions(
        this.filters,
        10000000,
        this.finraExceptionService.pageNumber,
        sortBy,
        1
      ).subscribe({
        next: (response:any) => {
          let data  = response.MATERIAL_LIST;
          if(data.length > 0) {
            for (const item of data) {
              let itemOriginalJSON = (item.originalJSON.length > 0 ? JSON.parse(item.originalJSON) : new Object());
              item.receiverIMID = itemOriginalJSON.receiverIMID;
            };
            const options: any = {
              fieldSeparator: ',',
              quoteStrings: '"',
              decimalSeparator: '.',
              showLabels: true,
              showTitle: true,
              title: value ?? '' +'_RSMS_FINRA_Exception_' + this.userService.getyyyyMMddDateFormate(new Date()),
              useTextFile: false,
              useBom: true,
              useKeysAsHeaders: true,
              // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
              filename: this.userService.getActiveMPID() + '_' + (value ?? '') +'_RSMS_FINRA_Exception_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
            };
            const csvData = this.constantService.getExportData(data, listCols);
            const csv = generateCsv(options)(csvData);
            const blob = asBlob(options)(csv);
            saveAs(blob,options.filename);
    
            this.messageService.add({ severity: 'success', summary: 'CounterParty Report', detail: 'Counter Party Report Exported Successfully' });
            this.userService.logUserActivity('Export Counterparty Report', null, {
              'Text1': 'File Downloaded Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
              'Text2': 'User Filter Parameters: ' + JSON.stringify(this.filters.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
            });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
            this.userService.logUserActivity('Export Counterparty Report', null, {
              'Text1': 'No data found',
              'Text2': 'User Filter Parameters: ' + JSON.stringify(this.filters.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
            });
          }
          this.emitterService.exportToCSVData.emit(true);
        }, error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
          this.userService.logUserActivity('Export Counterparty Report', null, {
            'Text1': 'Error while Exporting',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.filters.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
      });
    
  }
  onHide() {
    this.finraExceptionService.showCounterpartyReport = false;
  }
  getDateEmitter(){
    this.counterPartyReport.reportDate[0] = this.datepickerService.dateRange[0];
    this.counterPartyReport.reportDate[1] = this.datepickerService.dateRange[1];
    this.getDestinationList();
  }
}